import React, { useState, useEffect } from 'react';
import TabbedResumeForm from './TabbedResumeForm';
import ResumePreview from './ResumePreview';

function CreateResume() {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    mobile: '',
    email: '',
    link1: '',
    link2: '',
    objective: '',
    skills: [{ title: '', items: [''] }],
    experiences: [{ 
      designation: '', 
      company: '', 
      workSummary: [''], 
      startDate: '', 
      endDate: '' 
    }],
    projects: [{ name: '', summary: [''] }],
    education: [{ 
      name: '', 
      college: '', 
      startDate: '', 
      endDate: '' 
    }],
    certifications: [{ 
      name: '', 
      institution: '', 
      startDate: '', 
      endDate: '' 
    }]
  });

  const [showPreview, setShowPreview] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1280);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="create-resume-page">
      <div className="page-header">
        <div className="header-content">
          <div>
            <h1 className="page-title">Build Your Resume</h1>
            <p className="page-subtitle">Complete each section to create your professional resume</p>
          </div>
          {isMobile && (
            <button 
              className="preview-toggle"
              onClick={() => setShowPreview(!showPreview)}
            >
              {showPreview ? 'Hide Preview' : 'Show Preview'}
            </button>
          )}
        </div>
      </div>

      <div className="create-resume-container">
        <div className="form-section-wrapper">
          <TabbedResumeForm formData={formData} setFormData={setFormData} />
        </div>
        
        {/* Preview always visible on desktop, toggle on mobile */}
        <div className={`preview-section-wrapper ${showPreview && isMobile ? 'show-mobile' : ''}`}>
          <div className="preview-sticky">
            <div className="preview-header">
              <h3>Live Preview</h3>
              <div className="preview-badge">Real-time</div>
            </div>
            <div className="preview-container">
              <ResumePreview formData={formData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateResume;